import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">用户口碑</h2>
          <p className="mt-2 text-sm text-foreground-500">来自真实影迷的观影反馈，品质有目共睹</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.map((comment, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-lg p-5 border border-background-200/70 ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/15 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-semibold text-primary-400 font-heading">{comment.avatar}</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-700">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-4 mt-4 pt-3 border-t border-background-200">
                <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">
                  <i className="ri-thumb-up-line"></i> {comment.likes}
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">
                  <i className="ri-chat-1-line"></i> 回复
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors">
                  <i className="ri-share-forward-line"></i> 分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}